import type {
  CreateActivitySagaPayloadType,
  CreatePhaseSagaPayloadType,
  DeleteActivitySagaPayloadType,
  DeletePhaseSagaPayloadType,
  ReorderPhasesSagaPayloadType,
  UpdateActivitySagaPayloadType,
  UpdatePhaseSagaPayloadType,
} from "../../../slices/technology-settings/phases/Types";

export const technologySettingsPhasesSagaActionTypes = {
  callGetPhasesSaga: "callGetPhasesSaga",
  callCreatePhaseSaga: "callCreatePhaseSaga",
  callUpdatePhaseSaga: "callUpdatePhaseSaga",
  callCreateActivitySaga: "callCreateActivitySaga",
  callUpdateActivitySaga: "callUpdateActivitySaga",
  callReorderPhasesSaga: "callReorderPhasesSaga",
  callDeletePhaseSaga: "callDeletePhaseSaga",
  callDeleteActivitySaga: "callDeleteActivitySaga",
};

export const getPhasesSagaAction: () => { type: string } = () => ({
  type: technologySettingsPhasesSagaActionTypes.callGetPhasesSaga,
});

export const createPhaseSagaAction: (payload: CreatePhaseSagaPayloadType) => {
  type: string;
  payload: CreatePhaseSagaPayloadType;
} = (payload) => ({
  type: technologySettingsPhasesSagaActionTypes.callCreatePhaseSaga,
  payload,
});

export const updatePhaseSagaAction: (payload: UpdatePhaseSagaPayloadType) => {
  type: string;
  payload: UpdatePhaseSagaPayloadType;
} = (payload) => ({
  type: technologySettingsPhasesSagaActionTypes.callUpdatePhaseSaga,
  payload,
});

export const createActivitySagaAction: (payload: CreateActivitySagaPayloadType) => {
  type: string;
  payload: CreateActivitySagaPayloadType;
} = (payload) => ({
  type: technologySettingsPhasesSagaActionTypes.callCreateActivitySaga,
  payload,
});

export const updateActivitySagaAction: (payload: UpdateActivitySagaPayloadType) => {
  type: string;
  payload: UpdateActivitySagaPayloadType;
} = (payload) => ({
  type: technologySettingsPhasesSagaActionTypes.callUpdateActivitySaga,
  payload,
});

export const reorderPhasesSagaAction: (payload: ReorderPhasesSagaPayloadType) => {
  type: string;
  payload: ReorderPhasesSagaPayloadType;
} = (payload) => ({
  type: technologySettingsPhasesSagaActionTypes.callReorderPhasesSaga,
  payload,
});

export const deletePhaseSagaAction: (payload: DeletePhaseSagaPayloadType) => {
  type: string;
  payload: DeletePhaseSagaPayloadType;
} = (payload) => ({
  type: technologySettingsPhasesSagaActionTypes.callDeletePhaseSaga,
  payload,
});

export const deleteActivitySagaAction: (payload: DeleteActivitySagaPayloadType) => {
  type: string;
  payload: DeleteActivitySagaPayloadType;
} = (payload) => ({
  type: technologySettingsPhasesSagaActionTypes.callDeleteActivitySaga,
  payload,
});
